import styled from 'styled-components';

export const FieldWrapperElement = styled.div`
    margin-bottom: 16px;
    position: relative;
    width: 100%;
`;
